import React from 'react';
import mainimage from '../../Assets/Ankush/Aboutus.png'

const MainImage = () => {
  return (
    <div className="w-full border">
      {/* <img src="path_to_main_image" alt="Warehouse" /> */}
      <img src={mainimage} alt="NYC Logo" className="w-full" />
    </div>
  );
};

export default MainImage;
 